module.exports = __webpack_public_path__ + "img/forestry-works-logo.d0c431df.jpg";